<div
  class="relative flex w-full items-center justify-center border-b-1 border-gray-200 bg-white py-1">
  <div class="absolute left-4">
    <ng-content></ng-content>
  </div>
  <button (click)="onLogoClicked()">
    <img
      class="object-contain py-2"
      [priority]="true"
      ngSrc="@shared-core/images/vyda-diff.png"
      alt="Logo"
      height="30"
      width="78" />
  </button>
  <button
    class="absolute right-4 flex h-full items-center gap-x-2.5"
    #userMenuButton
    #menuTrigger="element"
    provideNativeElement
    (click)="toggleIsUserMenuOpened($event)">
    <span class="font-bold">{{ usersFullName() }}</span>
    <shared-core-material-icon
      class="scale-125 transition-transform"
      [ngClass]="{ 'rotate-180': isUserMenuOpened() }"
      name="arrow_drop_down" />
  </button>
  <shared-core-floating-menu
    [isOpened]="isUserMenuOpened()"
    [anchor]="userMenuButton"
    [trigger]="menuTrigger"
    [placement]="'bottom-end'"
    [offsetConfig]="{ main: 15 }"
    [class.hidden]="!isUserMenuOpened()"
    (outsideClick)="isUserMenuOpened.set(false)"
    class="absolute z-20">
    <shared-core-floating-menu-item
      class="shadow-floating-container w-fit rounded-xl bg-white py-4 text-base text-nowrap">
      @for (item of userMenuItems; track $index) {
        <button class="hover:bg-primary/50 px-6 py-1" (click)="item.callback()">
          {{ item.label }}
        </button>
      }
    </shared-core-floating-menu-item>
  </shared-core-floating-menu>
</div>
